import {createRouter, createWebHistory} from "vue-router"
import WidgetPage from "@/pages/WidgetPage";
import AuthForm from "@/pages/auth/AuthForm";
import MainScreen from "@/navigation/MainScreen";

import {auth} from "@/state/auth";
import UsersPage from "@/pages/users/UsersPage";
import UserPage from "@/pages/users/UserPage";
import ScriptPage from "@/pages/projects/ScriptPage";
import Flow from "@/pages/flow/Flow";
import UserProfile from "@/pages/users/UserProfile";
import ProjectPage from "@/pages/projects/ProjectPage";
import ProjectsPage from "@/pages/projects/ProjectsPage";
import InventoryPage from "@/pages/inventory/InventoryPage";
import MyProjectsPage from "@/pages/projects/MyProjectsPage";
import MyProjectPage from "@/pages/projects/MyProjectPage";
import DeveloperPage from "@/pages/DeveloperPage";
import ResourcePage from "@/pages/inventory/ResourcePage";
import LoadTestPage from "@/pages/loadtest/LoadTestPage";
import {config} from "@/state/config";


let router = null;

function initRouter() {

  router = createRouter({
    history: createWebHistory(),
    routes: [
      {
        path: "/", component: MainScreen, children: [
          {path: "", name: "main", redirect: {name: "myprojects"}},
          {path: 'profile', name: "profile", component: UserProfile},

          {path: 'users', name: "users", component: UsersPage, meta: {admin: true}},
          {path: 'newuser', name: "newuser", component: UserPage, meta: {admin: true}},
          {path: 'users/:login', name: "user", component: UserPage, props: true, meta: {admin: true}},

          {path: 'projects', name: "projects", component: ProjectsPage, meta: {admin: true}},
          {path: 'newproject', name: "newproject", component: ProjectPage, meta: {admin: true}},
          {path: 'projects/:project_id', name: "project", component: ProjectPage, props: true, meta: {admin: true}},

          {path: 'myprojects', name: "myprojects", component: MyProjectsPage},
          {path: 'myprojects/:project_id', name: "myproject", component: MyProjectPage, props: true},

          {path: 'myprojects/:project_id/newscript', name: "newscript", component: ScriptPage, props: true},
          {path: 'myprojects/:project_id/script/:script_id', name: "script", component: ScriptPage, props: true},

          {path: 'inventory', name: "inventory", component: InventoryPage, meta: {admin: true}},
          {path: 'inventory/newresource', name: "newresource", component: ResourcePage, meta: {admin: true}},
          {path: 'inventory/resource/:name', name: "resource", component: ResourcePage, props: true, meta: {admin: true}},

          ...(config.devMode ? [
            {path: "developer", name: "developer", component: DeveloperPage, meta: {admin: true}},
            {path: "loadtest", name: "loadtest", component: LoadTestPage, meta: {admin: true}},
          ] : []),

        ]
      },
      {path: '/flow/:project_id/:script_id', name: "flow", component: Flow, props: true},
      {path: "/u/:pid/:uid", name: "wuser", component: WidgetPage, props: true},
      ...(config.keycloak ? [] : [
        {path: "/signin", name: "signin", component: AuthForm},
      ]),
      {path: "/:notFound(.*)", redirect: {name: "main"}},
    ]
  });

  router.beforeEach(async to => {
    if (!config.keycloak) {
      if (to.query.otl) {
        try {
          await auth.oneTimeLogin(to.query.otl);
        } catch (e) {
          console.log("OTL error: " + e);
          return ({name: "signin"});
        }
      }
      if (!auth.isLoggedIn() && to.name != 'signin') {
        return ({name: "signin"});
      } else if (auth.isLoggedIn() && to.name == 'signin') {
        return ({name: "main"});
      }
    }
    if (to.meta.admin && !auth.user.admin) {
      return ({name: "main"});
    }
  });

}

export {router, initRouter};

